//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import RbTrustPilot from '@/elements/trust-pilot/rb-trust-pilot.vue'

const { trustPilot } = wcs.getStoreConfig()
export default {
  name: 'rb-trust-pilot-typ',
  components: {
    RbTrustPilot,
  },
  data() {
    return {
      target: trustPilot.typ.target,
      templateId: trustPilot.typ.templateId,
    }
  },
}
